import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import ListView from "./ListView";
import ImageView from "./ImageView";
import {
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Typography,
  Button,
  Divider,
} from "@mui/material";
import GoogleLogin from "./GoogleLogin";

const drawerWidth = 240;

function Sidebar({ userEmail, authCallback, onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const filters = [
    { label: "All", value: "all" },
    { label: "Annotated", value: "annotated" },
    { label: "Not annotated", value: "not_annotated" },
    { label: "Annotated by me", value: "annotated_by_me" },
    { label: "Candidates", value: "candidates" },
  ];

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: "border-box", padding: 2 },
      }}
    >
      <Typography variant="h5" gutterBottom>
        Labeller
      </Typography>

      <List>
        {filters.map((filter) => (
          <ListItemButton
            key={filter.value}
            onClick={() => navigate(`/?filter=${filter.value}`)}
          >
            <ListItemText primary={filter.label} />
          </ListItemButton>
        ))}
      </List>

      <Divider sx={{ my: 2 }} />

      <Box>
        <Typography variant="body1" sx={{ mb: 1 }}>
          {userEmail}
        </Typography>
        <Button variant="outlined" color="secondary" onClick={onLogout} fullWidth>
          Logout
        </Button>
      </Box>
    </Drawer>
  );
}

function App() {
  const [authToken, setAuthToken] = useState(localStorage.getItem("auth_token"));
  const [userEmail, setUserEmail] = useState(localStorage.getItem("user_email"));

  const authCallback = async (response) => {
    localStorage.setItem("auth_token", response.token);
    localStorage.setItem("user_email", response.email);
    setAuthToken(response.token);
    setUserEmail(response.email);
  }

  const onLogout = async () => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("user_email");
    setAuthToken(null);
    setUserEmail(null);
  };

  return userEmail
    ? (
      <BrowserRouter>
        <Box sx={{ display: "flex" }}>
          <Sidebar userEmail={userEmail} authCallback={authCallback} onLogout={onLogout} />
          <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
            <Routes>
              <Route path="/" element={<ListView authToken={authToken} onLogout={onLogout}/>} />
              <Route path="/image" element={<ImageView authToken={authToken} onLogout={onLogout}/>} />
            </Routes>
          </Box>
        </Box>
      </BrowserRouter>
    )
    : (
      <GoogleLogin authCallback={authCallback}/>
    );
}

export default App;
